import { Typography } from "@mui/material";
import { useLocalizedProperty } from "../../utils";

export const BOOKING_STATUS_COLOR_BY_KEY = {
    Active: "#068e06",
    Completed: "#0B94D8",
    Cancelled: "#D80B0B",
    RemovedFromBooking: "#D80B0B",
    Transformed: "#516e00ff",
};

/**
 * Booking status with appropriate color
 */
export const BookingStatusText = (props) => {
    const { status_key } = props.status;
    const getLocalizedProperty = useLocalizedProperty();
    const statusText = getLocalizedProperty(props.status, "status_name");

    if (!(status_key in BOOKING_STATUS_COLOR_BY_KEY)) {
        return (
            // Default color
            <Typography>{statusText}</Typography>
        );
    }

    const color = BOOKING_STATUS_COLOR_BY_KEY[status_key];
    return <Typography color={color}>{statusText}</Typography>;
};
